<!-- 巡检点位表格组件 -->
<template>
  <div class="point-table-container">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad" @selection-change="handleSelectionChange">
      <!-- 自定义点位编号列 -->
      <template slot="pointCode" slot-scope="{ row }">
        <span style="color: #409eff; cursor: pointer" @click="!selectMode">
          {{ row.pointCode }}
        </span>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" icon="el-icon-view" size="small" @click.stop="handleDetail(scope.row)">详情</el-button>
        <el-button type="text" icon="el-icon-circle-check" size="small" @click.stop="handleEnable(scope.row,)"> {{ scope.row.status==0?'启用':"停用" }}
        </el-button>
      </template>

      <!-- 自定义状态列 -->
      <template slot="status" slot-scope="{ row }">
        <el-tag :type="getStatusTagType(row.status)" size="small" effect="light">
          {{ getStatusText(row.status) }}
        </el-tag>
      </template>

      <template slot="inspectionPointExtRpcDtoListForm">
        <div v-if="!selectMode" class="ext-form-table-wrap">
          <form-table
            ref="extFormTable"
            :form-data="form"
            sub-list-key="inspectionPointExtRpcDtoList"
            :option-config="extTableOption"
            :show-item="showItem"
          />
        </div>
      </template>
    </avue-crud>
    <el-dialog title="巡检点位详情" :visible.sync="detailDialogVisible" width="900px" top="6vh" :append-to-body="true">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="点位编号">{{ detailData.pointCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="点位名称">{{ detailData.pointName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="基站编码">{{ detailData.baseStationCode || '-' }}</el-descriptions-item>
        <el-descriptions-item label="打卡位置">{{ getCheckPointLabel(detailData.checkPoint) }}</el-descriptions-item>
        <el-descriptions-item label="点位位置" :span="2">{{ detailData.pointLocation || '-' }}</el-descriptions-item>
        <el-descriptions-item label="经度">{{ detailData.longitude || '-' }}</el-descriptions-item>
        <el-descriptions-item label="纬度">{{ detailData.latitude || '-' }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="getStatusTagType(detailData.status)" size="small" effect="light">
            {{ getStatusText(detailData.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">{{ detailData.createTime || '-' }}</el-descriptions-item>
      </el-descriptions>

      <div class="detail-ext-section">
        <div class="detail-ext-title">巡检项明细</div>
        <el-table :data="detailExtList" border size="small" class="detail-ext-table" max-height="360">
          <el-table-column type="index" label="序号" width="56" align="center" />
          <el-table-column prop="associatedObjectName" label="巡检项" min-width="180" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.associatedObjectName || '-' }}</template>
          </el-table-column>
          <el-table-column prop="pointDetail" label="巡检规则" min-width="220" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.pointDetail || '-' }}</template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="detailDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { showItem } from "@/basic-common/util/common";
import { getList, add, update, remove, getDetail, updateStatus } from "../api";
import request from "@/router/axios";
import FormTable from "@/basic-common/components/FormTable.vue";

export default {
  name: "PointTable",
  mixins: [crudMixins],
  props: {
    // 是否是选择模式（选择模式下隐藏操作按钮）
    selectMode: {
      type: Boolean,
      default: false,
    },
    // 选择模式下的回调
    onSelect: {
      type: Function,
      default: null,
    },
    // 是否只显示启用的点位（用于选择模式）
    onlyEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormTable,
  },
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      detailDialogVisible: false,
      detailData: {},
      checkPointDict: [],
      defaultParams: {
        businessType: "inspection",
      },
      currentPoint: {},
      option: {
        ...this.$store.state.publicOption,
        rowKey: "pointCode",
        menu: !this.selectMode, // 选择模式下隐藏菜单
        addBtn: false,
        delBtn: false,
        editBtn: false,
        viewBtn: false,
        searchMenuSpan: 6,
        selection: this.selectMode, // 选择模式下启用多选
        column: [
          {
            label: "点位编号",
            prop: "pointCode",
            overHidden: true,
            search: true,
            addDisplay: false,
            editdisabled: false,
            searchLabelWidth: 100,
            searchSpan: 6,
            searchPlaceholder: "搜索点位编号",
            slot: true,
          },
          {
            label: "点位名称",
            prop: "pointName",
            search: true,
            formatter: (row) => {
              return row.pointName || "-";
            },
            rules: [
              {
                required: true,
                message: "请输入点位名称",
                trigger: ["change", 'blur'],
              },
            ],
          },
          {
            label: "基站编码",
            prop: "baseStationCode",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 100,
            searchPlaceholder: "搜索基站编码",
            maxlength: 64,
            formatter: (row) => {
              return row.baseStationCode || "-";
            },
            rules: [
              {
                required: true,
                message: "请输入基站编码",
                trigger: ["change", "blur"],
              },
              {
                pattern: /\S+/,
                message: "基站编码不能为空",
                trigger: ["change", "blur"],
              },
            ],
          },
          {
            label: "巡检项",
            prop: "associatedObjectId",
            type: "select",
            overHidden: true,
            searchSpan: 6,
            searchLabelWidth: 80,
            remote: true,
            dataType: "string",
            dicUrl:
              "/api/produce/inspectionitem/select/distinct/pycode?itemsName={{key}}",
            props: {
              label: "itemsName",
              value: "id",
            },
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            formatter: (row) => {
              const list = row.inspectionPointExtRpcDtoList;
              if (list && list.length) {
                const names = list
                  .map((x) => x.associatedObjectName)
                  .filter(Boolean);
                return names.length ? names.join("、") : "-";
              }
              return row.associatedObjectName || "-";
            },
          },
          {
            label: "打卡位置",
            prop: "checkPoint",
            type: "select",
            overHidden: true,
            search: false,
            dataType: "string",
            dicUrl:
              "/api/blade-system/dict-biz/dictionary?code=check_point",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择打卡位置",
                trigger: ["change", "blur"],
              },
            ],
          },
          {
            label: "经度",
            prop: "longitude",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.longitude || "-";
            },
            rules: [
              {
                required: true,
                message: "请输入经度",
                trigger: ["change", 'blur'],
              },
              {
                validator: (rule, value, callback) =>
                  this.validateLongitude(rule, value, callback),
                trigger: ["change", "blur"],
              },
            ],
          },
          {
            label: "纬度",
            prop: "latitude",
            overHidden: true,
            search: false,
            formatter: (row) => {
              return row.latitude || "-";
            },
            rules: [
              {
                required: true,
                message: "请输入纬度",
                trigger: ["change", "blur"],
              },
              {
                validator: (rule, value, callback) =>
                  this.validateLatitude(rule, value, callback),
                trigger: ["change", "blur"],
              },
            ],
          },
          {
            label: "状态",
            prop: "status",
            type: "select",
            overHidden: true,
            search: true,
            searchSpan: 6,
            searchLabelWidth: 80,
            showColumn: false,
            dataType: "string",
            value: "1",
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=enable_flag",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            rules: [
              {
                required: true,
                message: "请选择状态",
                trigger: ["change", 'blur'],
              },
            ],
            slot: true,
          },
          {
            label: "创建时间",
            prop: "createTime",
            type: "datetime",
            overHidden: true,
            search: false,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: true,
          },
          {
            label: "",
            labelWidth: 0,
            prop: "inspectionPointExtRpcDtoList",
            hide: true,
            span: 24,
            formslot: true,
            addDisplay: true,
            editDisplay: true,
            viewDisplay: true,
          },
        ],
      },
    };
  },
  computed: {
    detailExtList () {
      const list = this.detailData.inspectionPointExtRpcDtoList;
      return Array.isArray(list) ? list : [];
    },
    extTableOption () {
      const vm = this;
      const view = vm.openType === "view";
      return {
        columnType: view ? "view" : undefined,
        height: undefined,
        column: [
          { label: "序号", type: "index", width: 56 },
          {
            label: "巡检项",
            prop: "associatedObjectId",
            type: "select",
            required: true,
            minWidth: 200,
            disabled: view,
            remote: true,
            echoLabelField: "associatedObjectName",
            dicUrl:
              "/api/produce/inspectionitem/select/distinct/pycode?itemsName={{key}}",
            props: { label: "itemsName", value: "id" },
            dataType: "string",
            change (val, row, options) {
              const hit = (options || []).find(
                (o) => String(o.value) === String(val)
              );
              vm.$set(row, "associatedObjectName", hit ? hit.label : "");
            },
          },
          {
            label: "巡检规则",
            prop: "pointDetail",
            type: "input",
            minWidth: 220,
            disabled: view,
            bind: { maxlength: 200 },
          },
        ],
      };
    },
  },
    watch: {
    selectMode: {
      immediate: true,
      handler (val) {
        this.option.menu = !val;
        this.option.addBtn = false;
        this.option.delBtn = false;
        this.option.editBtn = false;
        this.option.selection = val;
        this.option.reserveSelection = !!val;
      },
    },
    onlyEnabled: {
      immediate: true,
      handler (val) {
        if (val) {
          // 只显示启用的点位
          this.defaultParams.status = 1;
        } else {
          delete this.defaultParams.status;
        }
      }
    }
  },
  methods: {
    showItem,
    normalizeDicList (res) {
      const body = res && res.data;
      if (Array.isArray(body)) {
        return body;
      }
      if (body && Array.isArray(body.data)) {
        return body.data;
      }
      if (body && body.data && Array.isArray(body.data.data)) {
        return body.data.data;
      }
      return [];
    },
    loadCheckPointDict () {
      if (this.checkPointDict.length) {
        return Promise.resolve(this.checkPointDict);
      }
      return request({
        url: "/api/blade-system/dict-biz/dictionary?code=check_point",
        method: "get",
      }).then((res) => {
        this.checkPointDict = this.normalizeDicList(res);
        return this.checkPointDict;
      }).catch(() => {
        this.checkPointDict = [];
        return [];
      });
    },
    getCheckPointLabel (value) {
      if (value === undefined || value === null || value === "") {
        return "-";
      }
      const hit = this.checkPointDict.find((item) =>
        String(item.dictKey) === String(value)
      );
      return hit ? hit.dictValue : String(value);
    },
    handleDetail (row) {
      if (!row || row.id == null || row.id === "") {
        this.detailData = { ...(row || {}) };
        this.detailDialogVisible = true;
        this.loadCheckPointDict();
        return;
      }
      this.detailData = { ...row };
      this.detailDialogVisible = true;
      Promise.all([
        this.apiConfig.getDetail(row.id),
        this.loadCheckPointDict(),
      ]).then(([res]) => {
        const data = res.data.data || res.data || {};
        this.detailData = { ...data };
      }).catch(() => {
        this.detailData = { ...row };
      });
    },
    normalizeCoordinate (value) {
      if (value === undefined || value === null) {
        return "";
      }
      return String(value).trim();
    },
    isCoordinateInRange (value, min, max) {
      const text = this.normalizeCoordinate(value);
      if (!/^-?(\d+|\d+\.\d+|\.\d+)$/.test(text)) {
        return false;
      }
      const num = Number(text);
      return !Number.isNaN(num) && num >= min && num <= max;
    },
    validateLongitude (rule, value, callback) {
      if (!this.isCoordinateInRange(value, -180, 180)) {
        callback(new Error("经度范围为 -180 到 180"));
        return;
      }
      callback();
    },
    validateLatitude (rule, value, callback) {
      if (!this.isCoordinateInRange(value, -90, 90)) {
        callback(new Error("纬度范围为 -90 到 90"));
        return;
      }
      callback();
    },
    normalizePointLocation (row) {
      const longitude = this.normalizeCoordinate(row.longitude);
      const latitude = this.normalizeCoordinate(row.latitude);
      if (!this.isCoordinateInRange(longitude, -180, 180)) {
        this.$message.warning("请输入有效经度，范围为 -180 到 180");
        return false;
      }
      if (!this.isCoordinateInRange(latitude, -90, 90)) {
        this.$message.warning("请输入有效纬度，范围为 -90 到 90");
        return false;
      }
      this.$set(row, "longitude", longitude);
      this.$set(row, "latitude", latitude);
      this.$set(row, "pointLocation", `${longitude},${latitude}`);
      return true;
    },
    resolveListPayload (res) {
      let payload = res && res.data;
      if (typeof payload === "string") {
        try {
          payload = JSON.parse(payload);
        } catch (e) {
          payload = {};
        }
      }
      if (payload && payload.data) {
        payload = payload.data;
      }
      if (payload && payload.data) {
        payload = payload.data;
      }
      if (typeof payload === "string") {
        try {
          payload = JSON.parse(payload);
        } catch (e) {
          payload = {};
        }
      }
      return payload || {};
    },
    resolveRecords (payload) {
      if (Array.isArray(payload)) {
        return payload;
      }
      if (payload && Array.isArray(payload.records)) {
        return payload.records;
      }
      if (payload && payload.records && typeof payload.records === "string") {
        try {
          const records = JSON.parse(payload.records);
          return Array.isArray(records) ? records : [];
        } catch (e) {
          return [];
        }
      }
      if (payload && Array.isArray(payload.rows)) {
        return payload.rows;
      }
      if (payload && Array.isArray(payload.list)) {
        return payload.list;
      }
      return [];
    },
    onLoad (page, params = {}) {
      if (this.initstate) {
        this.initstate = false;
        return;
      }
      this.queryData = this.formatParams(Object.assign({}, this.defaultParams, params, this.query));
      if (!this.apiConfig || !this.apiConfig.getList) {
        return;
      }
      this.loading = true;
      const requestParams = {
        ...this.queryData,
        page: page.currentPage,
        size: page.pageSize,
      };
      this.apiConfig.getList(requestParams).then((res) => {
        const payload = this.resolveListPayload(res);
        const records = this.resolveRecords(payload);
        const total = payload && payload.total != null ? Number(payload.total) : records.length;
        this.responseData = records;
        this.page.total = total > 0 ? total : records.length;
        this.data = records.map((item) => ({ ...item }));
        if (this.initCardData) {
          this.initCardData();
        } else {
          this.cardData = payload || {};
        }
        if (this.afterSearch) {
          this.afterSearch();
        }
      }).catch(() => {
        this.data = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    beforeOpen (done, type) {
      this.openType = type;
      if (["edit", "view"].includes(type) && this.apiConfig.getDetail) {
        this.apiConfig.getDetail(this.form.id).then((res) => {
          const data = res.data.data || res.data || {};
          this.form = data;
          const list = data.inspectionPointExtRpcDtoList;
          if (Array.isArray(list) && list.length) {
            this.$set(
              this.form,
              "inspectionPointExtRpcDtoList",
              list.map((row) => ({ ...row }))
            );
          }
          this.normalizeExtList(false);
          done();
        });
      } else {
        this.normalizeExtList(true);
        if (type === "add") {
          const s = this.form.status;
          if (s === undefined || s === null || s === "") {
            this.$set(this.form, "status", "1");
          }
        }
        done();
      }
    },
    normalizeExtList (isAdd) {
      let list = this.form.inspectionPointExtRpcDtoList;
      if (list != null && !Array.isArray(list)) {
        this.$set(this.form, "inspectionPointExtRpcDtoList", [list]);
        list = this.form.inspectionPointExtRpcDtoList;
      }
      if (!Array.isArray(list)) {
        this.$set(this.form, "inspectionPointExtRpcDtoList", []);
      }
      if (isAdd && this.form.inspectionPointExtRpcDtoList.length === 0) {
        this.form.inspectionPointExtRpcDtoList.push({});
      }
    },
    async rowSave (row, done, loading) {
      await this.submitPointRow(row, done, loading, (payload) =>
        this.apiConfig.add(payload)
      );
    },
    async rowUpdate (row, index, done, loading) {
      await this.submitPointRow(row, done, loading, (payload) =>
        this.apiConfig.update(payload)
      );
    },
    async submitPointRow (row, done, loading, requestFn) {
      if (!this.normalizePointLocation(row)) {
        loading();
        return;
      }
      if (!this.selectMode && this.$refs.extFormTable) {
        const subOk = await this.$refs.extFormTable.getValidate();
        if (!subOk) {
          loading();
          return;
        }
      }
      const list = row.inspectionPointExtRpcDtoList || [];
      if (!this.selectMode && list.length === 0) {
        this.$message.warning("请至少添加一条巡检项明细");
        loading();
        return;
      }
      list.forEach((r, i) => {
        this.$set(r, "sequenceNumber", i + 1);
      });
      requestFn(row).then(
        () => {
          this.selectionClear();
          this.onLoad(this.page);
          this.$message({ type: "success", message: "操作成功" });
          done();
        },
        () => {
          loading();
        }
      );
    },
    // 处理选择变化
    handleSelectionChange (selection) {
      if (this.selectMode && this.onSelect) {
        this.onSelect(selection);
      } else {
        this.selectionChange(selection);
      }
    },

    // 获取状态文本
    getStatusText (status) {
      const statusMap = {
        1: "启用",
        0: "禁用",
      };
      return statusMap[status] || "未知";
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const typeMap = {
        1: "success",
        0: "danger",
      };
      return typeMap[status] || "info";
    },
    // crud-mixins 在列表请求完成后调用；用于选择弹窗在数据就绪后回显勾选
    afterSearch () {
      if (this.selectMode) {
        this.$nextTick(() => {
          this.$emit("list-loaded", this.data);
        });
      }
    },
    handleEnable (row) {
    //   console.log(row, 'row00000');
      const { id, status } = row
      const statu = status === 0?1:0
      updateStatus({ ids:id, status:statu }).then(({ data }) => {
        this.onLoad(this.page);
        this.$message.success(data.msg)
      })
    },
    // 公开方法：刷新数据
    refresh () {
      this.onLoad(this.page);
    },

    // 公开方法：设置选中的行（用于回显）
    setSelection (selectedCodes = []) {
      const norm = (v) => String(v == null ? "" : v).trim();
      const codeSet = new Set(
        (selectedCodes || []).map(norm).filter(Boolean)
      );
      if (!codeSet.size) {
        return;
      }

      const apply = () => {
        const crud = this.$refs.crud;
        const table = crud && crud.$refs && crud.$refs.table;
        if (!table) {
          return;
        }

        const rows = this.data.filter((row) =>
          codeSet.has(norm(row.pointCode))
        );
        if (!rows.length) {
          return;
        }

        table.clearSelection();
        rows.forEach((row) => {
          table.toggleRowSelection(row, true);
        });
      };

      this.$nextTick(() => {
        apply();
        this.$nextTick(apply);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.point-table-container {
  ::v-deep .avue-crud__search {
    .el-form-item__label {
      font-weight: 500;
      color: #606266;
    }
  }

  ::v-deep .avue-crud__table {
    .el-table__header th {
      background-color: #fafafa;
      color: #606266;
      font-weight: 500;
    }
    .el-table__row:hover {
      background-color: #f5f7fa;
    }
  }

  ::v-deep .el-tag {
    border-radius: 4px;
    padding: 0 8px;
    font-size: 12px;
    font-weight: 500;
  }

  ::v-deep .el-button--text {
    padding: 0 8px;
    margin-right: 0;
  }

  .dialog-footer {
    text-align: right;

    .el-button {
      min-width: 80px;
    }
  }

  .point-detail-form {
    ::v-deep .el-form-item {
      margin-bottom: 15px;

      .el-form-item__label {
        color: #606266;
        font-weight: 500;
      }

      span {
        color: #303133;
      }
    }
  }

  .ext-form-table-wrap {
    width: 100%;
    margin-top: 4px;
    margin-bottom: 0;
  }

  /* 弹窗内主表表单项对齐 */
  ::v-deep .el-dialog__body .avue-form .el-form-item {
    margin-bottom: 18px;
  }

  ::v-deep .el-dialog__body .avue-form .el-form-item__label {
    padding-right: 12px;
    line-height: 32px;
  }

  ::v-deep .el-dialog__body .avue-form .el-form-item__content {
    line-height: 32px;
  }

  /* 子表 slot 外侧表单项不再占 label 列 */
  ::v-deep .el-dialog__body .avue-form .el-form-item:has(.ext-form-table-wrap) {
    > .el-form-item__label-wrap {
      display: none;
    }

    > .el-form-item__content {
      margin-left: 0 !important;
      clear: both;
    }
  }
  .detail-ext-section {
    margin-top: 16px;
  }

  .detail-ext-title {
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
  }

  .detail-ext-table {
    width: 100%;
  }
}
</style>
